export const processIconHandler = statusCode => {
    switch (statusCode) {
        case '7':
        case '8':
            return 'check-circle'
        case '4':
            return 'error'
        default:
            return 'clock'
    }
}

export const processClassesHandler = statusCode => {
    switch (statusCode) {
        case '7':
        case '8':
            return 'positive'
        case '4':
            return 'negative'
        default:
            return 'warning'
    }
}

export const iconModalMapper = statusCode => {
	switch (statusCode) {
		case '7':
		case '8':
			return 'status-line-success'
        case '4':
			return 'status-line-error'
		default:
			return 'status-line-pending'
    }
}

  export const colorStatusMapperModal = statusCode => {
	switch (statusCode) {
		case '7':
		case '8':
			return 'var(--positive)'
        case '4':
			return 'var(--negative)'
		default:
			return 'var(--warning)'
	}
}
